import {PaginaLogada} from "../../componentes";
import React, {useEffect, useState} from "react";
import {exibirMensagemErro, getUsuarioLogado} from "../../util";
import {DemandaServico} from "../../servicos";
import {BotaoMantine} from "../../componentes/botao/botao-mantine";
import {IconArchive, IconFileExcel, IconFileSearch} from "@tabler/icons-react";
import {Demanda} from "../../tipos/demanda";
import {MRT_Localization_PT_BR} from "mantine-react-table/locales/pt-BR";
import {MantineReactTable, MRT_ColumnDef, useMantineReactTable} from "mantine-react-table";
import {ActionIcon, Badge, Box, Tooltip} from "@mantine/core";
import {COR} from "../../config/constantes/constantes-mantine";

export default function ListaDemandasAsplan() {

  const [isCarregando, setIscarregando] = useState(false)
  const [dods, setDods] = useState<Demanda[]>([])

  const usuarioLogado = getUsuarioLogado()

  function carregarDemandas() {
    setIscarregando(true)
    DemandaServico.buscarDodsAsplan(usuarioLogado)
      .then(res => res.json())
      .then(dados => {
        console.log(dados)
        setDods(dados)
      })
      .finally(() => setIscarregando(false))
  }


  useEffect(() => {
    carregarDemandas()
  }, [])

  function baixarExportacao(demandas: Demanda[]) {
    if (demandas.length === 0) {
      exibirMensagemErro("Selecione ao menos uma demanda")
      return
    }
    DemandaServico.baixarDods(demandas)
  }

  const colunas: MRT_ColumnDef<Demanda>[] = [
    {
      accessorKey: 'id',
      header: 'ID',
    },
    {
      accessorKey: 'unidadeRequisitante',
      header: 'Unidade',
      filterVariant: 'autocomplete',
    },
    {
      accessorKey: 'forca.sigla',
      header: 'Força',
      filterVariant: 'autocomplete',
      Cell: ({renderedCellValue, row}) => (
        <Tooltip label={row.original.forca.nome}>
          <Badge color={row.original.forca.cor}>
            {renderedCellValue}
          </Badge>
        </Tooltip>
      ),
    },
    {
      accessorKey: 'items.length',
      header: 'Quantidade Items',
      filterVariant: 'range-slider',
      filterFn: 'betweenInclusive',
    },
    {
      accessorKey: 'dataSolicitacao',
      header: 'Data da Solicitação',
      Cell: ({cell}) => {
        return cell.getValue() != null ? new Date(cell.getValue<Date>()).toLocaleDateString() : ""
      },
      filterVariant: 'date-range',
    },
  ]

  const table = useMantineReactTable({
    columns: colunas,
    data: dods,
    enableRowSelection: true,
    enableRowActions: true,
    positionActionsColumn: 'last',
    enablePagination: true,
    enableFacetedValues: true,
    columnFilterDisplayMode: 'popover',
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    localization: MRT_Localization_PT_BR,
    renderRowActions: ({row}) => (
      <>
        <Tooltip label={"Visualizar Demanda"}>
          <ActionIcon
            ml={10}
            aria-label="Visualizar"
            color={COR.INFO}
            component={"a"}
            href={`/visualizarDemanda/${row.original.id}`}
          >
            <IconFileSearch/>
          </ActionIcon>
        </Tooltip>
        <Tooltip label={"Arquivar Demanda"}>
          <ActionIcon
            ml={10}
            aria-label="Arquivar Demanda"
            color={COR.ALERTA}
          >
            <IconArchive/>
          </ActionIcon>
        </Tooltip>
      </>
    ),
    renderTopToolbarCustomActions: ({table}) => (
      <Box
        style={{
          display: 'flex',
          gap: '16px',
          padding: '8px',
          flexWrap: 'wrap',
        }}
      >
        <BotaoMantine
          color={"green.6"}
          icone={IconFileExcel}
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          onClick={() => baixarExportacao(table.getPrePaginationRowModel().rows.map((row) => row.original))}
        >
          Exportar Todos
        </BotaoMantine>
        <BotaoMantine
          color={"green.8"}
          icone={IconFileExcel}
          disabled={!table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()}
          onClick={() => baixarExportacao(table.getSelectedRowModel().rows.map((row) => row.original))}
        >
          Exportar Selecionados
        </BotaoMantine>
      </Box>
    ),
  });

  return (
    <PaginaLogada titulo={"Listagem de DODs do setor: " + usuarioLogado?.setor?.nome} isCarregando={isCarregando}>
      <MantineReactTable table={table}/>
    </PaginaLogada>
  );
}
